<script>
import PModal from './components/p-modal'
export default {
  name: 'PrevidApp',
  components : {
    PModal
  },

  data() {
    return {
    }
  },
  created() {
  }
}
</script>

<template>
<div class="p-app">
  <slot></slot>
  <p-modal></p-modal>
   <notifications group="base" />
</div>
</template>


<style>
</style>



// WEBPACK FOOTER //
// src/js/Main.vue